module.exports = __webpack_public_path__ + "img/icons-complaint_blue.83a063ed.svg";